import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MessageToster from "../../component/MessageToster";
// import Loader from "../../component/Loader";
import { BASE_URL } from "../../api";
import { PASSWORD_REGEX } from "../../utils/regex";
import { getApiHeaders } from "../../utils/helpers";
import { AuthHeader } from "../../component/Logo";
import { APP_NAME } from "../../utils/constant";

export default function ResetPassword() {
  const navigate = useNavigate()
  const [showpass, setShowpass] = useState(false);
  const [confompass, setConfompass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resetDone, setResetDone] = useState(false);
  const [timer, setTimer] = useState(120);
  const [canResend, setCanResend] = useState(false);
  const [resending, setResending] = useState(false);
  const [input, setInput] = useState({
    verifycode: "",
    password: "",
    conformpassword: ""
  })
  const [validations, setValidations] = useState({
    verifycode: "",
    password: '',
    conformpassword: ""
  });

  const resetEmail = sessionStorage.getItem("resetEmail");

  useEffect(() => {
    if (!resetEmail && !resetDone) {
      navigate("/forgetpassword", { replace: true });
    }
  }, [resetEmail, resetDone, navigate]);

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const maskEmail = (email) => {
    if (!email) return "";
    const parts = email.split("@");
    if (parts.length !== 2) return email;
    const [name, domain] = parts;
    if (name.length <= 4) {
      return `${name.slice(0, 1)}***@${domain}`;
    }
    const visiblePrefix = name.slice(0, Math.min(9, Math.max(3, Math.ceil(name.length * 0.6))));
    return `${visiblePrefix}***@${domain}`;
  };

  const handleResendOTP = async () => {
    if (!canResend || resending || loading) return;
    setResending(true);
    try {
      const res = await axios.post(
        `${BASE_URL}/account/forgot_password`,
        {
          email: resetEmail,
          otype: "",
          mode: ""
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.code === 200) {
        MessageToster("success", res.data.message || "OTP resent successfully.");
        setTimer(120);
        setCanResend(false);
      } else {
        MessageToster("error", res.data.message || "Failed to resend OTP.");
      }
    } catch (err) {
      MessageToster("error", err.message || "Failed to resend OTP.");
    } finally {
      setResending(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !loading) {
      onSubmitForm(e);
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasteText = e.clipboardData ? e.clipboardData.getData("text") : "";
    const digitsOnly = pasteText.replace(/\D/g, "").slice(0, 6);
    if (digitsOnly) {
      setInput((prev) => ({ ...prev, verifycode: digitsOnly }));
      setValidations((prev) => ({ ...prev, verifycode: "" }));
    }
  };

  const handelChange = (e) => {
    const { name, value } = e.target;

    if (name === "verifycode") {
      const digits = value.replace(/\D/g, "").slice(0, 6);
      setInput((prev) => ({ ...prev, verifycode: digits }));
      setValidations((prev) => ({ ...prev, verifycode: "" }));
      return;
    }

    setInput({ ...input, [name]: value });
    setValidations({ ...validations, [name]: "" });
  };

  const validateOTP = () => {
    let hasError = false;

    const checkValidations = { ...validations };

    // if (!input.verifycode) {
    //   checkValidations.verifycode = "OTP is required";
    //   hasError = true;
    // } else if (input.verifycode.length < 6) {
    //   checkValidations.verifycode = "Enter a valid 6-digit OTP";
    //   hasError = true;
    // }

    if (!input.verifycode) {
      checkValidations.verifycode = "OTP is required";
      hasError = true;
    } else if (!/^\d{6}$/.test(input.verifycode)) {
      checkValidations.verifycode = "Enter a valid 6-digit OTP";
      hasError = true;
    }

    setValidations(prev => ({ ...prev, ...checkValidations }));

    return hasError;
  };


  const validatePassword = () => {
    let hasError = false;
    const checkValidations = {};

    if (!input.password) {
      checkValidations.password = "Password is required";
      hasError = true;
    } else if (input.password.length < 8) {
      checkValidations.password = "Password must be at least 8 characters long.";
      hasError = true;
    } else if (!PASSWORD_REGEX.test(input.password)) {
      checkValidations.password =
        "Password must include uppercase, lowercase, number, and special character.";
      hasError = true;
    }

    if (!input.conformpassword) {
      checkValidations.conformpassword = "Confirm password is required";
      hasError = true;
    } else if (input.password !== input.conformpassword) {
      checkValidations.conformpassword =
        "Password and Confirm password do not match.";
      hasError = true;
    }

    setValidations(prev => ({ ...prev, ...checkValidations }));
    return hasError;
  };


  const onSubmitForm = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (loading) return;

    const otpError = validateOTP();

    const passError = validatePassword();

    if (otpError || passError) return;

    // setLoading(true);
    await resetPassword();
  };

  const resetPassword = async () => {
    setLoading(true);

    const bodyData = {
      email: resetEmail,
      verifycode: input.verifycode,
      password: input.conformpassword
    };

    try {
      const res = await axios.post(`${BASE_URL}/account/reset_password`, bodyData, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        // setLoading(false);
        MessageToster("success", res.data.message);
        // alert("navigate /")
        // navigate("/")
        // sessionStorage.removeItem("resetEmail");
        setResetDone(true);

        sessionStorage.removeItem("resetEmail");
        navigate("/", { replace: true });

      } else {
        // setLoading(false);
        MessageToster("error", res.data.message);
      }

    } catch (err) {
      // setLoading(false);
      MessageToster("error", err.message || "Something went wrong. Please try again.")
      // console.error("Error Response:", err.response.data);
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <div className="account-pages login-pages py-2" style={{ minHeight: "100vh", height: "auto" }}>
        <div className="container">
          <div className="row justify-content-center w-100 mx-auto">
            <div className="col-md-8 col-lg-6 col-xl-6 px-1">
              <div className="card overflow-hidden shadow-sm my-auto">
                <AuthHeader
                  title="Reset password"
                  subtitle={<>Choose a new password for your <span className="notranslate" translate="no">{APP_NAME}</span> account.</>}
                />
                <div className="card-body pt-4 px-4 pb-4">
                  <div className="p-2">
                    <div className="form-horizontal">
                      <form onSubmit={onSubmitForm}>
                        {resetEmail && (
                          <div
                            className="alert alert-info border-0 d-flex align-items-center mb-3 p-3 rounded-3"
                            style={{ fontSize: "13px", lineHeight: "1.5" }}
                          >
                            <i className="bx bx-envelope font-size-22 me-2 text-info flex-shrink-0"></i>
                            <div>
                              <span className="text-muted">OTP has been sent to your email:</span>
                              <br />
                              <strong className="text-dark font-size-14">{maskEmail(resetEmail)}</strong>
                            </div>
                          </div>
                        )}

                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <label htmlFor="verifycode" className="form-label mb-0">
                              OTP
                            </label>
                            {timer > 0 ? (
                              <span className="text-muted font-size-12 d-flex align-items-center">
                                <i className="bx bx-time-five me-1 text-primary font-size-14"></i>
                                Resend in <strong className="text-primary ms-1">{formatTime(timer)}</strong>
                              </span>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-link p-0 font-size-12 text-primary text-decoration-none fw-semibold d-flex align-items-center"
                                onClick={handleResendOTP}
                                disabled={resending || loading}
                              >
                                {resending ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-1"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Sending...
                                  </>
                                ) : (
                                  <>
                                    <i className="bx bx-refresh me-1 font-size-15"></i> Resend OTP
                                  </>
                                )}
                              </button>
                            )}
                          </div>
                          <input
                            className="form-control text-center font-size-18 fw-bold"
                            style={{ letterSpacing: "8px", height: "42px" }}
                            type="text"
                            placeholder="------"
                            id="verifycode"
                            autoComplete="one-time-code"
                            value={input.verifycode}
                            onChange={handelChange}
                            onPaste={handleOtpPaste}
                            onKeyDown={handleKeyDown}
                            name="verifycode"
                            maxLength={6}
                            disabled={loading}
                          />
                          {validations.verifycode && (
                            <div className="text-danger small mt-1 d-flex align-items-center">
                              <i className="bx bx-info-circle me-1 font-size-14"></i>
                              <span>{validations.verifycode}</span>
                            </div>
                          )}
                        </div>

                        <div className="mb-3">
                          <label htmlFor="password" className="form-label mb-1">
                            Password
                          </label>
                          <div className="input-group auth-pass-inputgroup">
                            <input
                              className="form-control"
                              type={showpass ? "text" : "password"}
                              placeholder="Enter Your password"
                              id="password"
                              autoComplete="off"
                              value={input.password}
                              onChange={handelChange}
                              onKeyDown={handleKeyDown}
                              disabled={loading}
                              name="password"
                            />
                            <button
                              className="btn btn-light"
                              type="button"
                              id="password-addon"
                              onClick={() => setShowpass(!showpass)}
                              disabled={loading}
                            >
                              {showpass ? (
                                <i className="mdi mdi-eye-outline" />
                              ) : (
                                <i className="mdi mdi-eye-off-outline" />
                              )}
                            </button>
                          </div>
                          {validations.password && (
                            <div className="text-danger small mt-1 d-flex align-items-center">
                              <i className="bx bx-info-circle me-1 font-size-14"></i>
                              <span>{validations.password}</span>
                            </div>
                          )}
                        </div>

                        <div className="mb-3">
                          <label htmlFor="conformpassword" className="form-label mb-1">
                            Confirm Password
                          </label>
                          <div className="input-group auth-pass-inputgroup">
                            <input
                              className="form-control"
                              type={confompass ? "text" : "password"}
                              placeholder="Enter Your password"
                              id="conformpassword"
                              autoComplete="off"
                              value={input.conformpassword}
                              onChange={handelChange}
                              onKeyDown={handleKeyDown}
                              disabled={loading}
                              name="conformpassword"
                            />
                            <button
                              className="btn btn-light"
                              type="button"
                              id="conformpassword-addon"
                              onClick={() => setConfompass(!confompass)}
                              disabled={loading}
                            >
                              {confompass ? (
                                <i className="mdi mdi-eye-outline" />
                              ) : (
                                <i className="mdi mdi-eye-off-outline" />
                              )}
                            </button>
                          </div>
                          {validations.conformpassword && (
                            <div className="text-danger small mt-1 d-flex align-items-center">
                              <i className="bx bx-info-circle me-1 font-size-14"></i>
                              <span>{validations.conformpassword}</span>
                            </div>
                          )}
                        </div>

                        <div className="mt-4 d-grid">
                          <button
                            className="btn btn-primary waves-effect waves-light"
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span>Resetting...</span>
                              </>
                            ) : (
                              "Reset Password"
                            )}
                          </button>
                        </div>
                      </form>
                      <div className="mt-3 text-center">
                        <p className="mb-0">
                          <Link
                            className="fw-medium text-primary ps-2"
                            to="/"
                          >
                            <i className="mdi mdi-arrow-left me-1" /> Back to Login
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}
